import { Button, Col, Descriptions, Dropdown, Popconfirm, Row, Skeleton, Space, Tabs } from "antd";
import DescriptionsItem from "antd/es/descriptions/Item";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router";
import { date2locale } from "../common/common";
import { visitTypes } from "./NewMedicalVisit";
import { states } from "./MedicalVisits";
import PdfViewer from "../common/PdfViewer";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileOutlined,
  FullscreenOutlined,
  MoreOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import BackTitle from "../common/BackTitle";

const MedicalFitness = ({ medicalFitness }) => {
  const navigate = useNavigate();
  const [openFile, setOpenFile] = useState();
  return medicalFitness ? (
    <>
      <PdfViewer url={openFile} onClose={() => setOpenFile(null)} />
      <Descriptions
        layout="horizontal"
        title={
          <>
            Giudizio di idoneità{" "}
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() => navigate("editMedicalFitness")}
            />
          </>
        }
        column={1}
        colon={false}
        styles={{ label: { width: "50%" }, content: { width: "50%" } }}
      >
        <DescriptionsItem label="Giudizio">{medicalFitness?.outcome}</DescriptionsItem>
        <DescriptionsItem label="Data giudizio">
          {date2locale(medicalFitness?.date)}
        </DescriptionsItem>
        <DescriptionsItem label="Data scadenza">
          {date2locale(medicalFitness?.dueDate)}
        </DescriptionsItem>
        <DescriptionsItem label="Documento">
          <Button
            icon={<EyeOutlined />}
            onClick={() => setOpenFile(`medicalFitness/${medicalFitness.id}/file`)}
          >
            Visualizza
          </Button>
          `
        </DescriptionsItem>
      </Descriptions>
    </>
  ) : (
    <div>Giudizio di idoneità non caricato</div>
  );
};
export default function () {
  const [medicalVisit, setMedicalVisit] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const fetch = () => {
    setLoading(true);
    axiosInstance
      .get(`medicalVisit/${id}`)
      .then(({ data }) => setMedicalVisit(data))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    fetch();
  }, []);
  return (
    <>
      <BackTitle
        title="Dettagli visita medica"
        secondary={`ID: ${id} • ${states[medicalVisit.state]}`}
        extra={
          <Space size={4}>
            {!medicalVisit.medicalFitness && (
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={() => navigate("uploadMedicalFitness")}
              >
                Carica giudizio
              </Button>
            )}
          </Space>
        }
      />
      <Skeleton loading={loading} active>
        <Row gutter={24}>
          <Col span={12}>
            <Descriptions
              layout="horizontal"
              title={
                <>
                  Dati visita{" "}
                  <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
                </>
              }
              column={1}
              styles={{ label: { width: "50%" }, content: { width: "50%" } }}
              colon={false}
            >
              <DescriptionsItem label="Dipendente">
                {medicalVisit.employee?.fullName}
              </DescriptionsItem>
              <DescriptionsItem label="Medico competente">
                {medicalVisit.doctor?.firstName + " " + medicalVisit.doctor?.lastName}
              </DescriptionsItem>
              <DescriptionsItem label="Data">{date2locale(medicalVisit.date)}</DescriptionsItem>
              <DescriptionsItem label="Tipologia visita">
                {visitTypes[medicalVisit.type]}
              </DescriptionsItem>
              <DescriptionsItem label="Stato">{states[medicalVisit.state]}</DescriptionsItem>
              <DescriptionsItem label="Note">{medicalVisit.notes}</DescriptionsItem>
            </Descriptions>
          </Col>
          <Col span={12}>
            <MedicalFitness medicalFitness={medicalVisit.medicalFitness} />
          </Col>
        </Row>
      </Skeleton>
    </>
  );
}
